import React from "react";

import Layout from "components/Layout";
import Seo from "components/Seo";

import SubpageHeader from "components/SubpageHeader";
import ShareButton from "components/ShareButton";
import RealizationsSlider from "components/RealizationsSlider";
import RealizationMasonry from "components/RealizationMasonry";
import { graphql } from "gatsby";
import useTranslation from "locales";

import "styles/pages/single-realization.scss";

const SingleRealizationPage = ({ pageContext, data }) => {
	const pageContent = pageContext.data.portfolioAcf;
	const seo = pageContext.seo;
	const lang = pageContext.language?.slug;
	const allRealizations = data.allWpRealization.nodes;
	const realizationsFilteredByLang = allRealizations.filter((el) => {
		return el.language.slug === lang;
	});
	const { t } = useTranslation(lang);
	return (
		<Layout lang={lang}>
			<Seo title={seo.title ? seo.title : pageContext.title} />
			<SubpageHeader
				lang={lang}
				title={pageContext.title}
				variant
				back={t("/nasze-realizacje/")}
			/>
			<section className="single-realization">
				<div className="container">
					<div className="row">
						<div className="col-md-6 single-realization__info-col">
							{pageContent.city} <br />
							{pageContent.address}
						</div>
						<div className="col-md-6 single-realization__info-col">
							{pageContent.date}
						</div>
					</div>
					<div>
						<img
							src={pageContent.mainImg?.sourceUrl}
							alt=""
							className="single-realization__hero-image"
						/>
					</div>
					<div className="row">
						<div className="col-lg-2 col-sm-10 single-realization__content-col">
							<img
								src={pageContent.logo?.sourceUrl}
								alt={pageContext.title}
							/>
						</div>
						<div className="col-lg-7 offset-lg-1 single-realization__content-col single-realization__paragraph">
							<h5 className="single-realization__title">
								{pageContent.shortDesc}
							</h5>
							<div
								dangerouslySetInnerHTML={{
									__html: pageContent.content,
								}}
							/>
						</div>
						<div className="col-lg-1 col-sm-2 offset-lg-1 single-realization__content-col">
							<ShareButton />
						</div>
					</div>
				</div>
			</section>
			<div className="single-realization__slider">
				<div
					className={
						pageContent?.slider?.length < 3 ? "container" : ""
					}
				>
					<div
						className={
							pageContent?.slider?.length < 3
								? "row justify-content-center"
								: ""
						}
					>
						{pageContent?.slider?.length < 3 &&
						pageContent?.slider?.length > 0 ? (
							pageContent?.slider?.map((item, index) => {
								return (
									<div
										className={`col-lg-${
											12 / pageContent?.slider?.length
										}`}
										key={index}
									>
										<img
											src={item.sourceUrl}
											alt=""
											className="img-fluid"
										/>
									</div>
								);
							})
						) : (
							<RealizationsSlider
								center
								images={pageContent.slider}
							/>
						)}
					</div>
				</div>
			</div>

			<section className="single-realization__afterword">
				<div className="container">
					<div className="col-lg-7 offset-lg-3">
						<div
							dangerouslySetInnerHTML={{
								__html: pageContent.afterword,
							}}
						/>
					</div>

					<div className="single-realization__see-more">
						<h3 className="single-realization__see-more-title">
							{t("Zobacz więcej")}
						</h3>
						<RealizationMasonry
							options={realizationsFilteredByLang}
							qty={2}
						/>
						{/* <div className="row">
              <div className="col-md-5">
                <ContactDetails phoneContact lang={lang} />
              </div>
              <div className="col-lg-5 col-md-6 offset-md-1">
                <ContactDetails media lang={lang} />
              </div>
            </div> */}
					</div>
				</div>
			</section>
		</Layout>
	);
};

export const query = graphql`
	query {
		allWpRealization(sort: { order: DESC, fields: date }) {
			nodes {
				portfolioAcf {
					city
					mainImg {
						sourceUrl
					}
					logo {
						sourceUrl
					}
					year
				}
				language {
					slug
				}
				slug
				title
				uri
			}
		}
	}
`;

export default SingleRealizationPage;
